import './i18n/autoTranslate';
// // ForgotPassword.jsx
// import React, { useState } from "react";
// import { ArrowLeft, Mail, CheckCircle, Wand2, Loader2 } from "lucide-react";
// import Input from "../components/ui/Input";
// import Button from "../components/ui/Button";
// import { Link } from "react-router-dom";
// import AppBackground from '../components/ui/AppBackground.tsx';

// import SpotlightCard from "../components/ui/SpotlightCard";
// import { useToast } from "../hooks/use-toast";
// import { MdOutlineLockReset } from "react-icons/md";
// import { API_BASE_URL } from "../config/api";

// export default function ForgotPassword() {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [emailSent, setEmailSent] = useState(false);
//   const { toast } = useToast();

// // In ForgotPassword.jsx - Update the handleSubmit function
// const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
    
//     try {
//       const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email }),
//       });
  
//       // Check if response has content before parsing JSON
//       const contentType = response.headers.get("content-type");
//       if (contentType && contentType.includes("application/json")) {
//         const data = await response.json();
        
//         if (response.ok) {
//           setEmailSent(true);
//           toast({
//             title: "Email Sent Successfully",
//             description: "Check your inbox for the password reset link",
//           });
//         } else {
//           toast({
//             variant: "destructive",
//             title: "Failed to send email",
//             description: data.message || "Please try again later",
//           });
//         }
//       } else {
//         // Handle non-JSON response
//         const text = await response.text();
//         console.error("Non-JSON response:", text);
//         toast({
//           variant: "destructive",
//           title: "Server Error",
//           description: "Unexpected response from server",
//         });
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast({
//         variant: "destructive",
//         title: "Connection Error",
//         description: "Unable to connect to server. Please try again.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (emailSent) {
//     return (
//       <AppBackground className="min-h-screen bg-[#0B0B12] text-white overflow-hidden">
//         {/* Navigation */}
//               <nav className="fixed top-0 w-full py-4 px-6 bg-black/20 backdrop-blur-xl border-b border-white/10" style={{zIndex:99999}}>
//                 <div className="max-w-7xl mx-auto flex items-center justify-between">
//                   <Link to="/" className="flex items-center space-x-3">
//                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
//                       <i className="ri-speak-ai-line text-4xl"></i>
//                     </div>
//                     <div className="flex flex-col">
//                       <h1 className="text-lg font-semibold text-foreground">InterviewGenieAI</h1>
//                       <span className="text-xs text-muted-foreground">Professional Assistant</span>
//                     </div>
//                   </Link>
//                   {/* <div className="flex items-center gap-2">
//                     <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
//                       <Bot size={24} />
//                     </div>
//                     <span className="font-bold text-xl">InterviewAI</span>
//                   </div> */}
                  
//                   <div className="hidden md:flex items-center gap-8">
//                     <a href="#features" className="text-sm hover:text-purple-300 transition-colors">Features</a>
//                     <Link to="/pricing" className="text-sm hover:text-purple-300 transition-colors">Pricing</Link>
//                     <a href="#faq" className="text-sm hover:text-purple-300 transition-colors">Resources</a>
//                   </div>
                  
//                   <div className="flex items-center gap-4">
//                     <Link to={'/sign-up'} className="text-sm hover:text-purple-300 transition-colors hidden md:block">Sign in</Link>
//                     <Link to={'/login'} className="bg-gradient-to-r  from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all button-glow">
//                       Login
//                     </Link>
//                   </div>
//                 </div>
//               </nav>
        
//         <main className="relative z-10 pt-10 pb-24">
//           <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
//             <div className="mb-8 text-center">
//               <h1 className="text-3xl md:text-4xl font-headline font-bold glowing-text mb-2">
//                 Check Your Email
//               </h1>
//               <p className="text-muted-foreground text-lg">
//                 We've sent a password reset link to your inbox
//               </p>
//             </div>

//             <SpotlightCard
//               className="custom-spotlight-card"
//               spotlightColor="rgba(34, 197, 94, 0.15)"
//             >
//               <div className="bg-gradient-to-br from-[rgba(30,30,46,0.8)] via-[rgba(30,30,46,0.7)] to-[rgba(46,46,69,0.4)] border border-white/10 p-8">
//                 <div className="text-center space-y-6">
//                   <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-500/20 border border-green-500/30">
//                     <CheckCircle className="h-10 w-10 text-green-400" />
//                   </div>
                  
//                   <div className="space-y-3">
//                     <h2 className="text-2xl font-bold text-white">Reset Link Sent!</h2>
//                     <p className="text-gray-400">
//                       We've sent a password reset link to: 
//                       <span className="text-white font-medium block mt-1">{email}</span>
//                     </p>
//                   </div>

//                   <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
//                     <p className="text-sm text-blue-300">
//                       📧 The reset link will expire in 1 hour for security reasons.
//                     </p>
//                   </div>

//                   <div className="pt-4 space-y-3">
//                     <Link to="/login" className="block">
//                       <Button 
//                         variant="outline" 
//                         fullWidth 
//                         iconName={ArrowLeft} 
//                         iconPosition="left"
//                         className="border-white/10 hover:bg-white/5"
//                       >
//                         Back to Login
//                       </Button>
//                     </Link>
                    
//                     <Button 
//                       onClick={() => setEmailSent(false)}
//                       variant="ghost" 
//                       fullWidth
//                       className="text-gray-400 hover:text-white"
//                     >
//                       Try different email
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//             </SpotlightCard>
//           </div>
//         </main>
//       </AppBackground>
//     );
//   }

//   return (
//     <AppBackground>
//       {/* Navigation */}
//             <nav className="fixed top-0 w-full py-4 px-6 bg-black/20 backdrop-blur-xl border-b border-white/10" style={{zIndex:99999}}>
//               <div className="max-w-7xl mx-auto flex items-center justify-between">
//                 <Link to="/" className="flex items-center space-x-3">
//                   <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 bg-clip-text text-transparent">
//                     <i className="ri-speak-ai-line text-4xl"></i>
//                   </div>
//                   <div className="flex flex-col">
//                     <h1 className="text-lg font-semibold text-foreground">InterviewGenieAI</h1>
//                     <span className="text-xs text-muted-foreground">Professional Assistant</span>
//                   </div>
//                 </Link>
//                 {/* <div className="flex items-center gap-2">
//                   <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-600 flex items-center justify-center">
//                     <Bot size={24} />
//                   </div>
//                   <span className="font-bold text-xl">InterviewAI</span>
//                 </div> */}
                
//                 <div className="hidden md:flex items-center gap-8">
//                   <a href="#features" className="text-sm hover:text-purple-300 transition-colors">Features</a>
//                   <Link to="/pricing" className="text-sm hover:text-purple-300 transition-colors">Pricing</Link>
//                   <a href="#faq" className="text-sm hover:text-purple-300 transition-colors">Resources</a>
//                 </div>
                
//                 <div className="flex items-center gap-4">
//                   <Link to={'/sign-up'} className="text-sm hover:text-purple-300 transition-colors hidden md:block">Sign in</Link>
//                   <Link to={'/login'} className="bg-gradient-to-r  from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all button-glow">
//                     Login
//                   </Link>
//                 </div>
//               </div>
//             </nav>
      
//       <main className="relative z-10 pt-10 pb-24">
//         <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="mb-8 text-center">
//             <h1 className="text-3xl md:text-4xl font-headline font-bold glowing-text mb-2">
//               Reset Your Password
//             </h1>
//             <p className="text-muted-foreground text-lg">
//               Enter your email address to receive a password reset link
//             </p>
//           </div>

//           <SpotlightCard
//             className="custom-spotlight-card"
//             spotlightColor="rgba(99, 102, 241, 0.15)"
//           >
//             <div className="bg-gradient-to-br from-[rgba(30,30,46,0.8)] via-[rgba(30,30,46,0.7)] to-[rgba(46,46,69,0.4)] border border-white/10 p-8">
//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <div>
//                   <label className="block font-medium mb-3 text-lg">Email Address</label>
//                   <Input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     placeholder="your.email@example.com"
//                     required
//                     className="bg-white/5 border-white/10 text-white placeholder-gray-400 h-12 text-base"
//                   />
//                 </div>

//                 <Button
//                   type="submit"
//                   loading={loading}
//                   iconName={"MdOutlineLockReset"}
//                   iconPosition="left"
//                   fullWidth
//                   className="button-glow bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 h-12 text-base font-semibold"
//                   disabled={loading || !email}
//                 >
//                 <MdOutlineLockReset />
//                   {loading ? "Sending Reset Link..." : "Send Reset Link"}
//                 </Button>

//                 <div className="text-center pt-4">
//                   <Link to="/login">
//                     <Button 
//                       variant="ghost" 
//                       iconName={ArrowLeft} 
//                       iconPosition="left"
//                       className="text-gray-400 hover:text-white"
//                     >
//                       Back to Login
//                     </Button>
//                   </Link>
//                 </div>
//               </form>
//             </div>
//           </SpotlightCard>
//         </div>
//       </main>
//     </AppBackground>
//   );
// }


// ForgotPassword.jsx
import React, { useState } from "react";
import { ArrowLeft, CheckCircle, Mail, ShieldCheck, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import Input from "../components/ui/Input";
import Button from "../components/ui/Button";
import AppBackground from "../components/ui/AppBackground.tsx";
import SpotlightCard from "../components/ui/SpotlightCard";
import { useToast } from "../hooks/use-toast";
import { MdOutlineLockReset } from "react-icons/md";
import { API_BASE_URL } from "../config/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      // Only parse JSON if the response is JSON
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();

        if (response.ok) {
          setEmailSent(true);
          toast({
            title: "Email Sent Successfully",
            description: "Check your inbox for the password reset link",
          });
        } else {
          toast({
            variant: "destructive",
            title: "Failed to send email",
            description: data?.message || "Please try again later",
          });
        }
      } else {
        const text = await response.text();
        console.error("Non-JSON response:", text);
        toast({
          variant: "destructive",
          title: "Server Error",
          description: "Unexpected response from server",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast({
        variant: "destructive",
        title: "Connection Error",
        description: "Unable to connect to server. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const TopNav = () => (
    <nav
      className="fixed top-0 w-full py-4 px-4 sm:px-6 border-b border-white/10 bg-black/20 backdrop-blur-2xl"
      style={{ zIndex: 99999 }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="relative">
            <div className="absolute -inset-2 rounded-2xl bg-gradient-to-r from-purple-600/30 via-indigo-500/20 to-cyan-400/10 blur-xl" />
            <div className="relative flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10">
              <i className="ri-speak-ai-line text-3xl bg-gradient-to-r from-purple-400 to-indigo-300 bg-clip-text text-transparent" />
            </div>
          </div>

          <div className="flex flex-col leading-tight">
            <h1 className="text-sm sm:text-base font-semibold text-foreground">InterviewGenieAI</h1>
            <span className="text-[11px] text-muted-foreground">Secure Recovery Portal</span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-sm text-white/70 hover:text-white transition-colors">
            Features
          </a>
          <Link to="/pricing" className="text-sm text-white/70 hover:text-white transition-colors">
            Pricing
          </Link>
          <a href="#faq" className="text-sm text-white/70 hover:text-white transition-colors">
            Resources
          </a>
        </div>

        <div className="flex items-center gap-3">
          <Link to="/sign-up" className="hidden sm:block text-sm text-white/70 hover:text-white transition-colors">
            Sign up
          </Link>
          <Link
            to="/login"
            className="relative inline-flex items-center justify-center px-4 py-2 rounded-xl text-sm font-semibold text-white
                       bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500
                       shadow-[0_12px_30px_-14px_rgba(99,102,241,0.8)] ring-1 ring-white/10 transition-all"
          >
            <span className="absolute inset-0 rounded-xl opacity-0 hover:opacity-100 transition-opacity bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.25),transparent_55%)]" />
            <span className="relative">Login</span>
          </Link>
        </div>
      </div>
    </nav>
  );

  return (
    <AppBackground className="min-h-screen text-white overflow-hidden ">
      {/* Futuristic overlays */}
      <div className="pointer-events-none absolute inset-0 h-screen">
        <div className="absolute inset-0 opacity-40 [background-image:radial-gradient(circle_at_20%_10%,rgba(99,102,241,0.35),transparent_45%),radial-gradient(circle_at_80%_0%,rgba(168,85,247,0.30),transparent_45%),radial-gradient(circle_at_50%_100%,rgba(34,211,238,0.18),transparent_50%)]" />
        <div className="absolute inset-0 opacity-[0.18] grid-sweep [background-image:linear-gradient(to_right,rgba(255,255,255,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:64px_64px]" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/25 to-transparent" />
        <div className="absolute -top-28 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-indigo-500/10 blur-[90px]" />
        <div className="absolute -bottom-40 right-[-120px] h-[520px] w-[520px] rounded-full bg-purple-500/10 blur-[100px]" />
      </div>

      <TopNav />

      <main className="relative z-10 pt-40 pb-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
            {/* Left: futuristic hero */}
            <section className="space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 backdrop-blur-xl">
                <Sparkles className="h-4 w-4 text-purple-300" />
                <span className="text-xs text-white/80">Secure password recovery</span>
              </div>

              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-headline font-bold leading-tight">
                <span className="bg-gradient-to-r from-white via-white to-white/70 bg-clip-text text-transparent">
                  Reset access,
                </span>{" "}
                <span className="bg-gradient-to-r from-purple-300 via-indigo-300 to-cyan-200 bg-clip-text text-transparent">
                  instantly.
                </span>
              </h1>

              <p className="text-white/70 text-base sm:text-lg max-w-xl">
                We’ll send you a one-time secure link. No account details are revealed — and the link expires automatically.
              </p>

              <div className="grid sm:grid-cols-2 gap-4 max-w-xl">
                <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-xl">
                  <div className="flex items-center gap-2">
                    <ShieldCheck className="h-5 w-5 text-emerald-300" />
                    <p className="font-semibold text-white">Protected flow</p>
                  </div>
                  <p className="mt-2 text-sm text-white/65">
                    Signed link, short TTL, and safe responses to prevent email enumeration.
                  </p>
                </div>

                <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-xl">
                  <div className="flex items-center gap-2">
                    <Mail className="h-5 w-5 text-indigo-300" />
                    <p className="font-semibold text-white">Fast delivery</p>
                  </div>
                  <p className="mt-2 text-sm text-white/65">
                    Works on mobile + desktop. Open the email, click, set a new password.
                  </p>
                </div>
              </div>

              <div className="flex items-center gap-3 text-xs text-white/50">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400/80" />
                <span>Tip: check Promotions / Spam if you don’t see the email.</span>
              </div>
            </section>

            {/* Right: card */}
            <section>
              <SpotlightCard
                className="custom-spotlight-card rounded-3xl"
                spotlightColor={emailSent ? "rgba(34, 197, 94, 0.16)" : "rgba(99, 102, 241, 0.18)"}
              >
                <div className="rounded-3xl p-[1px] bg-gradient-to-br from-white/15 via-white/5 to-transparent">
                  <div className="rounded-3xl bg-[linear-gradient(180deg,rgba(15,18,30,0.72),rgba(10,12,20,0.62))] backdrop-blur-xl border border-white/10">
                    {/* Header */}
                    <div className="px-6 sm:px-8 pt-7 pb-5 border-b border-white/10">
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <div className="absolute -inset-2 rounded-2xl bg-gradient-to-r from-purple-600/25 via-indigo-500/15 to-cyan-400/10 blur-xl" />
                            <div className="relative w-11 h-11 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center">
                              {emailSent ? (
                                <CheckCircle className="h-6 w-6 text-emerald-300" />
                              ) : (
                                <MdOutlineLockReset className="text-2xl text-indigo-200" />
                              )}
                            </div>
                          </div>

                          <div className="leading-tight">
                            <h2 className="text-lg font-semibold text-white">
                              {emailSent ? "Check your email" : "Reset your password"}
                            </h2>
                            <p className="text-sm text-white/60">
                              {emailSent ? "We sent a secure link to your inbox" : "Enter your email to receive a secure link"}
                            </p>
                          </div>
                        </div>

                        <div className="hidden sm:block text-xs text-white/45">
                          Expires in <span className="text-white/70 font-semibold">60 min</span>
                        </div>
                      </div>
                    </div>

                    {/* Body */}
                    <div className="px-6 sm:px-8 py-7">
                      {emailSent ? (
                        <div className="space-y-5">
                          <div className="rounded-2xl border border-emerald-500/20 bg-emerald-500/10 p-4">
                            <p className="text-sm text-emerald-100/90">
                              Reset link sent to:
                              <span className="block mt-1 font-semibold text-white break-all">{email}</span>
                            </p>
                          </div>

                          <div className="space-y-3">
                            <Step n="1" title="Open your inbox" desc="Look for the reset email from InterviewGenieAI." />
                            <Step n="2" title="Click the secure link" desc="The link is unique and expires automatically." />
                            <Step n="3" title="Set a new password" desc="You’ll be redirected to create a new password." />
                          </div>

                          <div className="pt-2 space-y-3">
                            <Link to="/login" className="block">
                              <Button
                                variant="outline"
                                fullWidth
                                iconName={ArrowLeft}
                                iconPosition="left"
                                className="border-white/10 hover:bg-white/5"
                              >
                                Back to Login
                              </Button>
                            </Link>

                            <Button
                              onClick={() => setEmailSent(false)}
                              variant="ghost"
                              fullWidth
                              className="text-white/60 hover:text-white"
                            >
                              Use a different email
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <form onSubmit={handleSubmit} className="space-y-6">
                          <div>
                            <label className="block font-medium mb-3 text-white/90">Email Address</label>

                            <div className="relative">
                              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-white/45">
                                <Mail className="h-5 w-5" />
                              </div>

                              <Input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your.email@example.com"
                                required
                                className="bg-white/5 border-white/10 text-white placeholder-white/35 h-12 text-base pl-11
                                           focus:border-indigo-400/40 focus:ring-2 focus:ring-indigo-500/20"
                              />
                            </div>

                            <p className="mt-2 text-xs text-white/50">
                              We’ll email you a secure link. If you don’t have access to this email, contact support.
                            </p>
                          </div>

                          <Button
                            type="submit"
                            loading={loading}
                            iconName={MdOutlineLockReset}
                            iconPosition="left"
                            fullWidth
                            className="h-12 text-base font-semibold button-glow
                                       bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500"
                            disabled={loading || !email}
                          >
                            {loading ? "Sending Reset Link..." : "Send Reset Link"}
                          </Button>

                          <div className="text-center pt-2">
                            <Link to="/login">
                              <Button
                                variant="ghost"
                                iconName={ArrowLeft}
                                iconPosition="left"
                                className="text-white/60 hover:text-white"
                              >
                                Back to Login
                              </Button>
                            </Link>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </SpotlightCard>
            </section>
          </div>
        </div>
      </main>

      <style>{`
        .grid-sweep {
          animation: gridSweep 18s linear infinite;
          will-change: transform;
        }
        @keyframes gridSweep {
          0% { transform: translate3d(0,0,0); }
          100% { transform: translate3d(-64px,-64px,0); }
        }
      `}</style>
    </AppBackground>
  );
}

function Step({ n, title, desc }) {
  return (
    <div className="flex gap-3">
      <div className="mt-0.5 h-7 w-7 shrink-0 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-xs font-bold text-white/80">
        {n}
      </div>
      <div>
        <p className="text-sm font-semibold text-white">{title}</p>
        <p className="text-sm text-white/60">{desc}</p>
      </div>
    </div>
  );
}
